import { render, staticRenderFns } from "./crearTipoDevolucion.vue?vue&type=template&id=320f8d42"
import script from "./crearTipoDevolucion.vue?vue&type=script&lang=js"
export * from "./crearTipoDevolucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports